import { useEffect, useState } from "react";
import { FADE_MS, SENTENCE_HOLD_MS } from "../constants";

type SwappingTextOptions = {
  sentenceHoldMs?: number;
  fadeMs?: number;
};

const useSwappingText = (sentences: string[], { sentenceHoldMs = SENTENCE_HOLD_MS, fadeMs = FADE_MS }: SwappingTextOptions = {}) => {
  const [cycle, setCycle] = useState(0);
  const [visible, setVisible] = useState(true);
  const text = sentences.length ? sentences[cycle % sentences.length] : "";

  useEffect(() => {
    if (sentences.length < 2) return;

    let timer = setTimeout(() => {
      setVisible(false);
      timer = setTimeout(() => {
        setCycle((prev) => prev + 1);
        setVisible(true);
      }, fadeMs);
    }, sentenceHoldMs);

    return () => clearTimeout(timer);
  }, [cycle, sentences.length, sentenceHoldMs, fadeMs]);

  return { text, visible };
};

export {useSwappingText};
export type {SwappingTextOptions};